<template>
  <div class="Investment-box artical-section">
    <div class="head-text">
      <ul class="breadcrumbs-list">
        <a href="javascript:void(0)" @click="backButton"><li>FinTalk</li></a>
        <a href="javascript:void(0)" @click="backToCategory"><li>&nbsp;>&nbsp;Category</li></a>
        <a href="javascript:void(0)" @click="articals"><li>&nbsp;>&nbsp;Article</li></a>
        <li>&nbsp;>&nbsp;Read Article</li>
      </ul>
      <h1>{{type}}</h1>
    </div>
    <div class="card-box equities-section">
      <div class="artical-detail">
        <div class="d-flex">
          <div class="imgfield">
             <v-img max-height="60" max-width="60" :src="titleIcon" :lazy-src="titleIcon">
                        </v-img>
          </div>
          <div class="contentfield">
            <v-list-item-title
              >{{title}}</v-list-item-title
            >
            <v-list-item-subtitle
              >Published: {{published_at}}</v-list-item-subtitle
            >
          </div>
        </div>
        <div class="content">
          <div  v-html = "description">
          </div>
        </div>
        <div class="artical-detail-btn">
          <button class="nemia-button active" @click="articleList">CLICK TO READ</button>
        </div>
      </div>
      <p class="articalhor"></p>
      <div class="similar-artical">
        <h2>Similar Articles</h2>
        <v-row>
          <template>
            <v-card class="mx-auto" outlined  v-for="(article_list_item,index) in similar_article_list" :key="index">
              <v-list-item three-line>
                <v-list-item-content>
                  <div class="d-flex">
                    <div class="imgfield">
                      <v-img max-height="60" max-width="60" :src="titleIcon" :lazy-src="titleIcon">
                        </v-img>
                    </div>
                    <div class="contentfield">
                      <v-list-item-title
                        >{{article_list_item.title}}</v-list-item-title
                      >
                      <v-list-item-subtitle
                        >Published: {{article_list_item.created_at}}</v-list-item-subtitle
                      >
                      <a class="fullArtical" @click="readSimilarArticle(article_list_item.id)"
                        >Read full article</a
                      >
                    </div>
                  </div>
                </v-list-item-content>
              </v-list-item>
            </v-card>
          </template>
        </v-row>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
export default {
  data: function () {
    return {
      arrowRight: './bondimg.png',
      titleIcon: '',
      type: this.$route.params.category_name ,
      article_id: this.$route.params.article_id ,
      description:'',
      title:'',
      published_at:'',
      similar_article_list:[],
      cat_id:'',

    };
  },
  mounted() {
    this.readFinTalkArticle()
  },
  methods: {
    backButton() {
      this.$router.push({ name: "FinTalk"}).catch(()=>{});
    },
    readArticle() {
      this.$router.push({ 
          name: 'FinTalkArticles',
          params: { category: category_id, category_name: type,img:this.img, props: true },
       });
    },
    
     readFinTalkArticle(){
      let cognito_idp = atob(localStorage.getItem('cognito_idp'));
      let formdata = new FormData();
      formdata.append('aws_cognito_id', cognito_idp);
      formdata.append('article_id', this.article_id);
      axios
        .post(
          process.env.VUE_APP_ROOT_API + 'read-fintalk-article',
          formdata,
          {
            headers: {
              'Content-Type': 'multipart/form-data',
              'Access-Control-Allow-Origin': '*',
            },
          }
        )
        .then((response) => {
          this.description  = response.data.data.description
          this.img = response.data.data.image_without_logo;
          this.logoImg = response.data.data.image_with_logo;
          this.title  = response.data.data.title
          this.published_at  = response.data.data.created_at
          this.titleIcon = process.env.VUE_APP_ROOT_ICONS_URL + response.data.cat_detail.web_icon
          this.similar_article_list = response.data.similar_article_list
          this.cat_id = response.data.data.fintalk_category_id
        });
     },

     articleList(){
        this.$router.push({
          name: 'ReadFullArticles',
          params: { category: this.cat_id,category_name: this.type,article_id:this.article_id,img:this.img, title:this.title, props: true },
        });
     },

     readSimilarArticle(id){
        let cognito_idp = atob(localStorage.getItem('cognito_idp'));
        let formdata = new FormData();
        formdata.append('aws_cognito_id', cognito_idp);
        formdata.append('article_id', id);
        axios
          .post(
            process.env.VUE_APP_ROOT_API + 'read-fintalk-article',
            formdata,
            {
              headers: {
                'Content-Type': 'multipart/form-data',
                'Access-Control-Allow-Origin': '*',
              },
            }
          )
          .then((response) => {
            this.description  = response.data.data.description
            this.title  = response.data.data.title
            this.published_at  = response.data.data.created_at
            this.titleIcon = process.env.VUE_APP_ROOT_ICONS_URL + response.data.cat_detail.web_icon
            this.similar_article_list = response.data.similar_article_list
            this.cat_id = response.data.data.fintalk_category_id
          });
     },

     articals(){
        this.$router.push({
          name: 'FinTalkArticles',
          params: { category: this.cat_id, category_name: this.type, props: true },
        });
     },

    backToCategory(){
       this.$router.push({ name: "FinTalkCategory"}).catch(()=>{});
     }
  },
};
</script>
